<template>
	<div>
		<v-layout v-if="anythingChanged" row wrap>
			<v-flex d-flex xs1>
				<v-card :color="lighterCellColor">
					<v-card-text v-if="!subRow" class="text-xs-center">
						<div>
							<strong>
								{{index}}
							</strong>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs5>
				<v-flex v-if="subRow" d-flex xs1>
					<v-card :color="darkerCellColor">
						<v-card-text class="text-xs-center">
							<div>
								<strong>
									{{index}}
								</strong>
							</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-card :color="darkerCellColor">
					<v-card-text>
						<b v-if="bold">
							<strong>
								{{label}} {{statusOld}}
							</strong>
						</b>
						<div v-else>
							<strong>
								{{label}} {{statusOld}}
							</strong>
						</div>

					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs3>
				<v-card :color="fromProjectColor">
					<v-card-text>
						<strong v-if="!documentOnly">
							{{otherFromProject}} {{isPercentage ? " %" : ""}}
						</strong>
						<strong v-else>-</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs3>
				<v-card :color="fromDocumentsColor">
					<v-card-text>
						<strong>
							{{otherFromDocument}} {{isPercentage ? " %" : ""}}
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex d-flex xs1>
				<v-card :color="lighterCellColor">
					<v-card-text v-if="!subRow" class="text-xs-center">
						<div>
							<strong>
								{{index}}
							</strong>
						</div>

					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs5>
				<v-flex v-if="subRow" d-flex xs1>
					<v-card :color="darkerCellColor">
						<v-card-text class="text-xs-center">
							<div>
								<strong>
									{{index}}
								</strong>
							</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-card :color="darkerCellColor">
					<v-card-text>
						<b v-if="bold">
							<strong>
								{{label}} {{statusCurrent}}
							</strong>
						</b>
						<div v-else>
							<strong>
								{{label}} {{statusCurrent}}
							</strong>
						</div>

					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs3>
				<v-card :color="fromProjectColor">
					<v-card-text>
						<strong v-if="!documentOnly">
							{{fromProject}} {{isPercentage ? " %" : ""}}
						</strong>
						<strong v-else>-</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs3>
				<v-card :color="fromDocumentsColor">
					<v-card-text>
						<strong>
							{{fromDocument}} {{isPercentage ? " %" : ""}}
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
	import {FinalReportComparisonUtils} from "./Utils/FinalReportComparisonUtils";
	import {ComparisonResult} from "./Utils/ComparisonResult";

	export default {
		name: 'FinalReportComparisonSummaryRow',
		props: {
			isPercentage: {
				type: Boolean,
				default: false,
			},
			subRow: {},
			index: {},
			label: {},
			fromDocument: {},
			fromProject: {},
			otherFromDocument: {},
			otherFromProject: {},
			bold: {},
			documentOnly: {
				type: Boolean,
				default: false,
			},
		},

		computed: {

			lighterCellColor () {
				return FinalReportComparisonUtils.comparisonColor(this.statusOld, -5);
			},

			darkerCellColor () {
				return FinalReportComparisonUtils.comparisonColor(this.statusOld, -4);
			},

			statusOld () {
				return this.anythingChanged ? ComparisonResult.changedOldVersion : ComparisonResult.same;
			},

			statusCurrent () {
				return this.anythingChanged ? ComparisonResult.changedNewVersion : ComparisonResult.same;
			},

			anythingChanged () {
				return this.fromDocument !== this.otherFromDocument
					|| this.fromProject !== this.otherFromProject;
			},

			fromDocumentsColor () {
				let status = FinalReportComparisonUtils.getComparisonStatusSingleProperty(
					this.fromDocument,
					this.otherFromDocument,
					false,
					true);
				return FinalReportComparisonUtils.comparisonColor(status, this.subRow ? -5 : -4);

			},

			fromProjectColor () {
				let status = FinalReportComparisonUtils.getComparisonStatusSingleProperty(
					this.fromProject,
					this.otherFromProject,
					false,
					true);
				return FinalReportComparisonUtils.comparisonColor(status, this.subRow ? -5 : -4);
			}
		}
	};
</script>
